import Components from "slotworks/components/components";
import AnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";
import { SymbolBehaviourMethod } from "slotworks/components/matrix/symbol/behaviours/symbol-behaviour-driver";
import bonusSymbolSetup from "utils/bonus-symbol-setup";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import isMcSymbol from "utils/is-mc-symbol";
import Layers from "slotworks/graphics/layers/layers";
import { LLCustomLayers } from "names";
import MCSymbolBorderAnimationBehaviour from "components/matrix/symbol/behaviours/mc-symbol-border-behaviour";

class LightningBorderAnimationUtil {

    public useBaseLightningBorder() {
        // this.setupBorderAnimation("base");
        // this.start();
    }

    public useBonusLightningBorder() {
        this.setupBorderAnimation("bonus");
        this.start();
    }

    public start() {

        this.enable();

        Components.matrix.getGridSymbols().forEach((symbol) => {
            const behaviour = symbol.getBehaviourByName<MCSymbolBorderAnimationBehaviour>("MCSymbolBorderAnimationBehaviour");
            if (behaviour && isMcSymbol(symbol.symbolId)) {
                symbol.executeBehaviour(SymbolBehaviourMethod.Land).execute();
                behaviour.continuous = true;
            }
        });
    }

    public enable() {
        Components.matrix.getAllSymbols().forEach((symbol) => {
            const behaviour = symbol.getBehaviourByName<MCSymbolBorderAnimationBehaviour>("MCSymbolBorderAnimationBehaviour");
            if (behaviour) {
                behaviour.continuous = true;
            }
        });
    }

    public stop() {
        Components.matrix.getAllSymbols().forEach((symbol) => this.stopForSymbol(symbol));
    }

    public stopForSymbol(symbol: SymbolComponent) {
        const behaviour = symbol.getBehaviourByName<MCSymbolBorderAnimationBehaviour>("MCSymbolBorderAnimationBehaviour");
        if (behaviour) {
            behaviour.continuous = false;
            behaviour.static();
        }
    }

    private setupBorderAnimation(type: string) {
        Components.matrix.getAllSymbols().forEach((symbol) => {
            const behaviour = new MCSymbolBorderAnimationBehaviour(symbol, `bonus_symbol_frame`);
            behaviour.validSymbols = bonusSymbolSetup.getSymbolIds();
            behaviour.continuous = true;
            behaviour.animationLayer = Layers.Custom.get(LLCustomLayers.HOLD_AND_SPIN_BORDER);
            symbol.addBehaviour(behaviour);
        });
    }
}

export default new LightningBorderAnimationUtil();
